import { ChangeEvent, FC, FocusEventHandler } from 'react';
import { Checkbox } from '@mui/material';
import Icons from '../../Assets/svgIcons';
import Text from '../Text';

export interface CheckboxDataProperties {
	checked?: boolean;
	disabled?: boolean;

	id: string;
	label?: string;
}

interface CheckBoxProperties {
	item: CheckboxDataProperties;
	onBlur?: FocusEventHandler<HTMLButtonElement>;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	style?: object;
}

const CustomCheckBox: FC<CheckBoxProperties> = ({ item, onChange, onBlur, style = {} }) => (
	<label htmlFor={item.id} style={{ display: 'flex', gap: 4, alignItems: 'center', cursor: item.disabled ? 'default' : 'pointer', ...style }}>
		<Checkbox
			id={item.id}
			name={item.id}
			checked={item.checked}
			onChange={onChange}
			onBlur={onBlur}
			disabled={item.disabled}
			icon={<Icons.CheckboxIcon disabled={item.disabled} />}
			checkedIcon={<Icons.CheckboxChecked disabled={item.disabled} />}
		/>
		<Text title={item.label ?? ''} type="psm" />
	</label>
);

export default CustomCheckBox;
